import React from 'react';
import { TMUA_PEARSON_TOKENS } from '../constants/tmuaPearsonTokens';

export default function TmuaPearsonDialog({
  title,
  children,
  onYes,
  onNo,
  onOk,
  yesLabel = 'Yes',
  noLabel = 'No',
  okLabel = 'OK',
  info = false,
}) {
  const T = TMUA_PEARSON_TOKENS;
  const isOkOnly = typeof onOk === 'function' && !onYes;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10050,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="tmua-pearson-dialog-title"
        style={{
          width: 420,
          maxWidth: '92vw',
          background: T.dialogBg,
          color: T.dialogFg,
          fontFamily: T.fontUi,
          boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
        }}
      >
        <div
          id="tmua-pearson-dialog-title"
          style={{
            padding: '8px 12px',
            fontSize: 14,
            fontWeight: 700,
            borderBottom: '1px solid rgba(255,255,255,0.25)',
          }}
        >
          {title}
        </div>
        <div style={{ padding: '16px 16px 12px', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
          {info ? (
            <span
              aria-hidden="true"
              style={{
                flex: 'none',
                width: 28,
                height: 28,
                borderRadius: '50%',
                border: `2px solid ${T.dialogFg}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
                fontSize: 16,
              }}
            >
              i
            </span>
          ) : null}
          <div style={{ fontSize: 13, lineHeight: 1.5 }}>{children}</div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '0 12px 12px' }}>
          {isOkOnly ? (
            <button
              type="button"
              onClick={onOk}
              style={{
                minWidth: 64,
                height: 26,
                background: T.nextDefaultBg,
                color: '#14161F',
                border: 'none',
                fontFamily: T.fontUi,
                fontSize: 13,
                fontWeight: 700,
                cursor: 'pointer',
              }}
            >
              {okLabel}
            </button>
          ) : (
            <>
              <button
                type="button"
                onClick={onYes}
                style={{
                  minWidth: 64,
                  height: 26,
                  background: T.nextDefaultBg,
                  color: '#14161F',
                  border: 'none',
                  fontFamily: T.fontUi,
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: 'pointer',
                }}
              >
                <u>Y</u>es
              </button>
              <button
                type="button"
                onClick={onNo}
                style={{
                  minWidth: 64,
                  height: 26,
                  background: 'transparent',
                  color: T.dialogFg,
                  border: `1px solid ${T.dialogFg}`,
                  fontFamily: T.fontUi,
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: 'pointer',
                }}
              >
                <u>N</u>o
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
